import {FacetValuesSortOrder, HibuFacetFilter, HibuFacetGroup, HibuFilter} from '../facet.types';

export type FilterAction =
    {
        readonly type: 'FILTERS/SET_FACETS';
        facets: HibuFacetGroup[];
    } |
    {
        readonly type: 'FILTERS/CHANGE_PERSISTENCE';
        filterPersisted: boolean;
    } |
    {
        readonly type: 'FILTERS/SELECT_FILTER';
        filter: HibuFilter;
        group: string;
    } |
    {
        readonly type: 'FILTERS/UNSELECT_FILTER';
        filter: HibuFilter;
        group: string;
    } |
    {
        readonly type: 'FILTERS/UPDATE_ALL';
        filters: HibuFacetFilter;
    } |
    {
        readonly type: 'FILTERS/CLEAR_ALL_SELECTED';
    } |
    {
        readonly type: 'FILTERS/EXPAND_GROUP';
        group: string;
    } |
    {
        readonly type: 'FILTERS/COLLAPSE_GROUP';
        group: string;
    } |
    {
        readonly type: 'FILTERS/CHANGE_SORT';
        sort: FacetValuesSortOrder;
    } |
    {
        readonly type: 'FILTERS/CHANGE_VISIBILITY';
        showFilters: boolean;
    } |
    {
        readonly type: 'FILTERS/CHANGE_PENDING_STATE';
        filtersPending: boolean;
    };

export function setFacets(
    facets: HibuFacetGroup[],
): FilterAction {
    return {
        type: 'FILTERS/SET_FACETS',
        facets: facets,
    };
}

export function changeFilterPersistence(
    filterPersisted: boolean,
): FilterAction {
    return {
        type: 'FILTERS/CHANGE_PERSISTENCE',
        filterPersisted: filterPersisted,
    };
}

export function selectFilter(
    filter: HibuFilter,
    group: string,
): FilterAction {
    return {
        type: 'FILTERS/SELECT_FILTER',
        filter: filter,
        group: group
    };
}

export function unselectFilter(
    filter: HibuFilter,
    group: string,
): FilterAction {
    return {
        type: 'FILTERS/UNSELECT_FILTER',
        filter: filter,
        group: group
    };
}

export function updateAllFilters(
    filters: HibuFacetFilter,
): FilterAction {
    return {
        type: 'FILTERS/UPDATE_ALL',
        filters: filters,
    };
}

export function clearAllSelectedFilters(): FilterAction {
    return {
        type: 'FILTERS/CLEAR_ALL_SELECTED',
    };
}

export function expandFilterGroup(
    group: string,
): FilterAction {
    return {
        type: 'FILTERS/EXPAND_GROUP',
        group: group,
    };
}

export function collapseFilterGroup(
    group: string,
): FilterAction {
    return {
        type: 'FILTERS/COLLAPSE_GROUP',
        group: group,
    };
}

export function changeSort(
    sort: FacetValuesSortOrder,
): FilterAction {
    return {
        type: 'FILTERS/CHANGE_SORT',
        sort: sort,
    };
}

export function changeVisibility(
    showFilters: boolean,
): FilterAction {
    return {
        type: 'FILTERS/CHANGE_VISIBILITY',
        showFilters: showFilters,
    };
}

export function changePendingState(
    filtersPending: boolean,
): FilterAction {
    return {
        type: 'FILTERS/CHANGE_PENDING_STATE',
        filtersPending: filtersPending,
    };
}
